import BaseDomoIframe from './BaseDomoIframe';
import { FrameProps } from './types';

function DomoIframeCampaign({ campaignId = null }: FrameProps) {
  return <BaseDomoIframe IframeName="Campaign" campaignId={campaignId} />;
}

export default DomoIframeCampaign;
